(function(){
  function run(){
    var s=document.querySelector('.calculator aside .summary'), m=document.querySelector('.calculator main'), btn=document.getElementById('add-to-cart'); if(!s||!m||!btn) return;
    var a=s.parentElement;
    var naast=a.getBoundingClientRect().left>=m.getBoundingClientRect().right-4;
    a.classList.toggle('pdc-naast',naast);
    var bb=btn.getBoundingClientRect().bottom-s.getBoundingClientRect().top;
    var top=Math.min(130,Math.round(innerHeight-bb-24));
    a.style.setProperty('--pdc-top',top+'px');
    var tel=a.querySelector('a.tel_link'); if(tel&&tel.getAttribute('href')!=='tel:+31202101486') tel.setAttribute('href','tel:+31202101486');
  }
  var t; function soon(){ clearTimeout(t); t=setTimeout(run,120); }
  window.addEventListener('resize',soon); window.addEventListener('load',soon);
  setInterval(run,800); soon();
})();
